export default {"closedPopupContainer":"LDnpr","logo":"_9rm-p"};